// | An action which can be triggered by the user.
import * as Effect$dClass from "../Effect.Class/index.js";
import * as Foreign$dObject from "../Foreign.Object/index.js";
import * as Partial from "../Partial/index.js";
import * as Restaumatic$dForm$dInternal from "../Restaumatic.Form.Internal/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dInternal$dIncremental from "../Specular.Internal.Incremental/index.js";
import * as Specular$dInternal$dIncremental$dNode from "../Specular.Internal.Incremental.Node/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
import * as Specular$dRef from "../Specular.Ref/index.js";
const $$new = /* #__PURE__ */ Specular$dRef.new(Effect$dClass.monadEffectEffect);
const mempty = v => () => {};
const Action = x => x;
const isActionFunctionEffectUni = {triggerImpl: f => f};
const isActionEffectUnit = {triggerImpl: f => v => f};
const isActionAction = {
  triggerImpl: v => param => {
    const $0 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(v.effect._1);
    return () => {
      const e = $0();
      return e(param)();
    };
  }
};
const initializeNoInitializerAc = () => ({makeImpl: v => Partial._crashWith("undefined")});
const hasFieldIdAction = {getFieldId: v => Restaumatic$dForm$dInternal.fieldPathToString(v.name)};
const triggerImpl = dict => dict.triggerImpl;
const isActionWithId = dictIsAction => ({triggerImpl: v => dictIsAction.triggerImpl(v._1.field)});
const trigger = dictIsAction => dictIsAction.triggerImpl;
const triggerCb = () => a => isActionAction.triggerImpl(a);
const trigger_ = dictIsAction => a => dictIsAction.triggerImpl(a)();
const makeEmptyAction = {
  makeEmptyImpl: opts => {
    const $0 = $$new(mempty);
    return () => {
      const e = $0();
      return {effect: e, name: opts.name};
    };
  }
};
const initializeNoInitialValueA = dictAnnTypeEquals => (
  {
    makeImpl: p => opts => Specular$dInternal$dRIO.bindImpl((() => {
      const $0 = $$new(mempty);
      return () => {
        const e = $0();
        return {effect: e, name: opts.name};
      };
    })())(v => Specular$dInternal$dRIO.pureImpl({field: v, init: v1 => initializer => v.effect._2(_old => v2 => dictAnnTypeEquals.proof(p)(a => a)(initializer))}))
  }
);
const initializeNoInitialValueA1 = dictAnnTypeEquals => (
  {
    makeImpl: p => opts => Specular$dInternal$dRIO.bindImpl((() => {
      const $0 = $$new(mempty);
      return () => {
        const e = $0();
        return {effect: e, name: opts.name};
      };
    })())(v => Specular$dInternal$dRIO.pureImpl({
      field: v,
      init: v1 => initializer => {
        const $0 = dictAnnTypeEquals.proof(p)(a => a)(initializer);
        return v.effect._2(_old => $0);
      }
    }))
  }
);
const effect = () => v => v1 => v1.effect._2(_old => v);
const effect_ = () => x => v1 => v1.effect._2(_old => v => x);
const dumpStateAction = {
  dumpState: v => {
    const n = Specular$dInternal$dIncremental.constant(Foreign$dObject.empty);
    Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
    return n;
  }
};
const addContextAction = {addContext: v => v1 => () => {}};
export {
  Action,
  addContextAction,
  dumpStateAction,
  effect,
  effect_,
  hasFieldIdAction,
  initializeNoInitialValueA,
  initializeNoInitialValueA1,
  initializeNoInitializerAc,
  isActionAction,
  isActionEffectUnit,
  isActionFunctionEffectUni,
  isActionWithId,
  makeEmptyAction,
  mempty,
  $$new as new,
  trigger,
  triggerCb,
  triggerImpl,
  trigger_
};
